let countryData;
function loadCountrySwitcher(){
    
    fetch(window.CountrySwitcherConfig.jsonUrl)
        .then(res => res.json())
        .then(data => {
            countryData = data;
            const currentStore = getCurrentStore(countryData.regions);
            updateCurrentStoreHeader(currentStore);
            createTabs(countryData.regions, currentStore);
            createCountries(countryData.regions, currentStore);
            

            /* country switcher start */
        const $toggle = $('header #locationDropdownToggle');
        const $panel = $('header #locationSlidePanel');
        const $closeBtn = $('header #locationPanelClose');
        const $dropdown = $('header .location-dropdown');
        countrySwitcher();

        

        

    });

    const input = document.querySelector('.location-search-input');

    input.addEventListener('input', function () {

        const keyword = this.value.trim().toLowerCase();

        const tabs = document.querySelector('.location-regions-tabs');
        const content = document.querySelector('.location-regions-content');
        const resultWrapper = document.querySelector('.location-search-results');
        resultWrapper.setAttribute('data-wg-notranslate', '');

        // Empty search → restore normal layout
        if (!keyword) {

            tabs.style.display = '';
            content.style.display = '';

            resultWrapper.style.display = 'none';
            resultWrapper.innerHTML = '';

            return;
        }

        tabs.style.display = 'none';
        content.style.display = 'none';

        resultWrapper.style.display = 'block';
        resultWrapper.innerHTML = '';

        countryData.regions.forEach(region => {

            let matchedCountries = '';

            region.countries.forEach(country => {

                if (country.name.toLowerCase().includes(keyword)) {
                    const currentStore = getCurrentStore(countryData.regions);
                    matchedCountries += createCountryCard(country, currentStore);
                }

            });

            if (matchedCountries) {

                resultWrapper.innerHTML += `
                    <div class="search-region">
                        <h3 class="region-title">${region.name}</h3>

                        <div class="countries-grid">
                            ${matchedCountries}
                        </div>
                    </div>
                `;

            }

        });

    });
    // Region tabs

}
function openPanel($panel,$dropdown) {
    if ($panel.is(':visible')) return;
    if ($('body').hasClass('open-nav-menu')) {
        $(".header .mobile-hamburger-wrapper").trigger('click');
    }
    $panel.stop(true, true).slideDown();
    $dropdown.addClass('active');
    $('body')
        .addClass('store-locator-opened')
        .css('overflow', 'hidden');
}

function closePanel($panel,$dropdown) {
    if (!$panel.is(':visible')) return;

    $panel.stop(true, true).slideUp();
    $dropdown.removeClass('active');
    $('body')
        .removeClass('store-locator-opened')
        .css('overflow', '');
}

function getCurrentStore(regions) {

    const currentUrl = window.location.href.toLowerCase();

    let matchedStore = null;
    let longestMatch = -1;

    regions.forEach(region => {
        region.countries.forEach(country => {
            country.languages.forEach(language => {

                const languageUrl = new URL(language.url.toLowerCase());

                const compareUrl =
                    languageUrl.origin +
                    languageUrl.pathname.replace(/\/$/, '');

                const currentCompare =
                    window.location.origin.toLowerCase() +
                    window.location.pathname.toLowerCase();

                if (
                    currentCompare.startsWith(compareUrl) &&
                    compareUrl.length > longestMatch
                ) {
                    longestMatch = compareUrl.length;

                    matchedStore = {
                        region,
                        country,
                        language
                    };
                }

            });
        });
    });

    return matchedStore;
}

function createTabs(regions, currentStore) {

    const container = document.querySelector('.location-regions-tabs');

    container.innerHTML='';
    const hasActiveMatch =
        !!currentStore &&
        regions.some(region => region.name === currentStore.region.name);

    regions.forEach((region,index)=>{
        const target = `region-${region.name
        .toLowerCase()
        .replace(/\s+/g, '-')}`;
        const isActive = hasActiveMatch
            ? currentStore.region.name === region.name
            : index === 0;
        container.innerHTML += `
            <button class="region-tab ${isActive ? 'active' : ''}"
                data-target="${target}">
                ${region.name}
            </button>
        `;

    });

}

function isMobileViewport() {
    // Adjust the breakpoint here if your CSS mobile breakpoint differs.
    return window.innerWidth <= 767;
}

function createCountries(regions, currentStore){

    const wrapper=document.querySelector('.location-regions-content');
    wrapper.setAttribute('data-wg-notranslate', ''); // add this line
    wrapper.innerHTML='';

    const onMobile = isMobileViewport();
    const hasActiveMatch =
        !!currentStore &&
        regions.some(region => region.name === currentStore.region.name);


    regions.forEach((region,index)=>{
        const dest = `region-${region.name
        .toLowerCase()
        .replace(/\s+/g, '-')}`;
        
        const isActive = hasActiveMatch
            ? currentStore.region.name === region.name
            : index === 0;

        let html=`

        <div class="region-content-group ${isActive ? 'active' : ''}"
        id="${dest}">

        <h3 class="region-title">${region.name}</h3>

        <div class="countries-grid">

        `;

        // Countries come from the JSON already alphabetically sorted.
        // On mobile only, move the active country to the front of its
        // own region and leave everything else in that same (alphabetical)
        // order. Desktop keeps the plain alphabetical order untouched.
        let countriesToRender = region.countries;

        if (
            onMobile &&
            currentStore &&
            currentStore.region.name === region.name
        ) {
            const activeCode = currentStore.country.country_code;

            const active = region.countries.filter(
                c => c.country_code === activeCode
            );
            const rest = region.countries.filter(
                c => c.country_code !== activeCode
            );

            countriesToRender = [...active, ...rest];
        }

        countriesToRender.forEach(country=>{

            html += createCountryCard(country, currentStore);

        });

        html+=`

        </div>

        </div>

        `;

        wrapper.innerHTML+=html;

    });

}

function bindLanguageSwitcher() {

    document.addEventListener('click', async function (e) {

        const link = e.target.closest('.country-languages a');
        if (!link) return;

        e.preventDefault();

        const targetUrl = link.href;
        const currentStore = getCurrentStore(countryData.regions);

        // Find selected language
        let selectedCountry = null;
        let selectedLanguage = null;

        outer:
        for (const region of countryData.regions) {
            for (const country of region.countries) {
                for (const language of country.languages) {

                    const target = new URL(targetUrl);
                    const lang = new URL(language.url);

                    if (
                        target.origin === lang.origin &&
                        target.pathname.replace(/\/$/, '') ===
                        lang.pathname.replace(/\/$/, '')
                    ) {
                        selectedCountry = country;
                        selectedLanguage = language;
                        break outer;
                    }
                }
            }
        }

        if (!selectedCountry || !selectedLanguage) {
            window.location.href = targetUrl;
            return;
        }

        // Different country -> normal redirect (to that country's base/home URL)
        // (also covers the global store case, where currentStore/currentStore.country
        // is undefined - treat that the same as "different country")
        if (!currentStore?.country || selectedCountry.country_code !== currentStore.country.country_code) {
            window.location.href = targetUrl;
            return;
        }

        // ------------------------
        // Same country -> keep the current page, just swap locale prefix
        // ------------------------
        const currentPath = window.location.pathname;
        let pagePath = currentPath;

        // Normalize both sides the same way so trailing-slash inconsistencies
        // in the JSON (some entries have one, some don't) can't break this
        const stripTrailingSlash = (p) => p.replace(/\/$/, '');
        const currentLocale = stripTrailingSlash(new URL(currentStore.language.url).pathname);

        if (currentLocale !== '') {
            if (stripTrailingSlash(pagePath) === currentLocale) {
                pagePath = '/';
            } else if (pagePath.startsWith(currentLocale + '/')) {
                pagePath = pagePath.substring(currentLocale.length);
            }
        }

        if (!pagePath.startsWith('/')) {
            pagePath = '/' + pagePath;
        }

        const targetBase = new URL(selectedLanguage.url).origin +
            stripTrailingSlash(new URL(selectedLanguage.url).pathname);

        const finalUrl = targetBase + (pagePath === '/' ? '' : pagePath);

        // Best-effort existence check only — never fall back to the bare
        // homepage URL, since that can get silently re-redirected to the
        // old locale by server-side geo/cookie logic and looks like this
        // whole feature "not working".
        try {
            const response = await fetch(finalUrl, {
                method: 'HEAD',
                redirect: 'follow'
            });

            window.location.href = response.ok ? finalUrl : finalUrl;
            // ^ intentionally go to finalUrl either way (see note below)

        } catch (err) {
            window.location.href = finalUrl;
        }

    });
}

function createCountryCard(country, currentStore){
    const isActiveCountry =
    currentStore &&
    currentStore.country.country_code === country.country_code;
    let languages='';
    const cartIcon = country.is_cart ? `
    <div class="icon-wrap mobile">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 14.9999C8.1903 14.9999 8.74991 15.5596 8.75 16.2499C8.75 16.9402 8.19036 17.4999 7.5 17.4999C6.8097 17.4998 6.25 16.9402 6.25 16.2499C6.25009 15.5596 6.80975 14.9999 7.5 14.9999ZM13.75 14.9999C14.4403 14.9999 14.9999 15.5596 15 16.2499C15 16.9402 14.4404 17.4999 13.75 17.4999C13.0597 17.4998 12.5 16.9402 12.5 16.2499C12.5001 15.5596 13.0598 14.9999 13.75 14.9999ZM5.3877 4.99988H16.875V5.80652L16.7812 5.96277L13.4756 11.2499H7.75684L6.9502 12.038C6.85703 12.1227 6.79175 12.2338 6.7627 12.3563C6.73374 12.4788 6.74193 12.607 6.78711 12.7245C6.83232 12.8419 6.91205 12.9431 7.01562 13.0145C7.11942 13.086 7.24313 13.1245 7.36914 13.1249H15V14.3749H7.36914C6.99257 14.3725 6.62532 14.2568 6.31543 14.0428C6.00549 13.8288 5.76644 13.5261 5.63086 13.1747C5.49546 12.8235 5.46899 12.4396 5.55469 12.0731C5.64052 11.7065 5.83496 11.3737 6.1123 11.119L6.7373 10.494L3.9873 4.99988H2.5V3.74988H4.7627L5.3877 4.99988ZM7.8877 9.99988H12.7812L15.125 6.24988H6.0127L7.8877 9.99988Z" fill="white"/>
        </svg>
    </div>
    ` : '';

    country.languages.forEach(language=>{
        const isActive =
        currentStore &&
        currentStore.language.url.toLowerCase() === language.url.toLowerCase();
        languages += `
            <li>
                <a
                    href="${language.url}"
                    data-language="${language.code}"
                    data-country="${country.country_code}"
                    class="${isActive ? 'active' : ''}">
                    <span>${language.code}</span>
                    <div class="tooltip-block">
                        ${language.name}
                    </div>
                </a>
            </li>`;
    });

    return `

    <div class="country-card ${isActiveCountry ? 'active' : ''}">
         <div class="country-flag">
        ${country.flag?.trim() ? `
           <img src="${country.flag}" alt="${country.name} flag">
           
        ` : ''}
         </div>

        <div class="country-details">
            <div class="left-wrap">
                <div class="country-name">
                    <span>
                        ${country.name}
                    </span>
                    ${cartIcon}
                </div>

                <ul class="country-languages">
                    ${languages}
                </ul>
            </div>

            ${country.is_cart ? `
                <div class="icon-wrap desktop">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.5 14.9999C8.1903 14.9999 8.74991 15.5596 8.75 16.2499C8.75 16.9402 8.19036 17.4999 7.5 17.4999C6.8097 17.4998 6.25 16.9402 6.25 16.2499C6.25009 15.5596 6.80975 14.9999 7.5 14.9999ZM13.75 14.9999C14.4403 14.9999 14.9999 15.5596 15 16.2499C15 16.9402 14.4404 17.4999 13.75 17.4999C13.0597 17.4998 12.5 16.9402 12.5 16.2499C12.5001 15.5596 13.0598 14.9999 13.75 14.9999ZM5.3877 4.99988H16.875V5.80652L16.7812 5.96277L13.4756 11.2499H7.75684L6.9502 12.038C6.85703 12.1227 6.79175 12.2338 6.7627 12.3563C6.73374 12.4788 6.74193 12.607 6.78711 12.7245C6.83232 12.8419 6.91205 12.9431 7.01562 13.0145C7.11942 13.086 7.24313 13.1245 7.36914 13.1249H15V14.3749H7.36914C6.99257 14.3725 6.62532 14.2568 6.31543 14.0428C6.00549 13.8288 5.76644 13.5261 5.63086 13.1747C5.49546 12.8235 5.46899 12.4396 5.55469 12.0731C5.64052 11.7065 5.83496 11.3737 6.1123 11.119L6.7373 10.494L3.9873 4.99988H2.5V3.74988H4.7627L5.3877 4.99988ZM7.8877 9.99988H12.7812L15.125 6.24988H6.0127L7.8877 9.99988Z" fill="white"/>
                    </svg>
                </div>
            ` : ''}
        </div>

    </div>`;

}

function updateCurrentStoreHeader(currentStore) {

    if (!currentStore) return;
    // ----------------------------
    // Update Header
    // ----------------------------
    const flagImg = document.querySelector('.location-selector .flag-icon img');
    const countryName = document.querySelector('.location-selector .country-name');

    if (flagImg) {
        flagImg.src = currentStore.country.flag;
        flagImg.alt = currentStore.country.name;
    }
    if (flagImg) {
        const flag = currentStore.country.flag;

        if (flag?.trim()) {
            flagImg.src = flag;
            flagImg.alt = currentStore.country.name;
        } else {
            flagImg.parentElement.style.display = 'none';
            $('#locationDropdownToggle').addClass('no-flag');
        }
    }

    // Show Country Name instead of Language Code
    if (countryName) {
        countryName.textContent = currentStore.country.country_code;
    }
    // ----------------------------
    // Update Selected Country Card
    // ----------------------------
    const selectedFlag = document.getElementById('selectedCountryFlag');
    const selectedCountryName = document.getElementById('selectedCountryName');
    const selectedLanguage = document.getElementById('selectedCountryLanguage');

    if (selectedFlag) {
        const flag = currentStore.country.flag;

        if (flag?.trim()) {
            selectedFlag.src = flag;
            selectedFlag.alt = currentStore.country.name;
        } else {
            selectedFlag.style.display = 'none';
        }
    }

    if (selectedCountryName) {
        selectedCountryName.textContent = currentStore.country.name;
    }

    if (selectedLanguage) {
        // Show every language available for the selected country (not just
        // the current one) so the user can switch language right from this
        // header widget. Re-uses the "country-languages" class/markup so
        // the existing delegated click handler in bindLanguageSwitcher()
        // (listens for `.country-languages a`) picks these up automatically
        // - no extra event binding needed here.
        let languagesHtml = '';

        currentStore.country.languages.forEach(language => {
            const isActive =
                currentStore.language.url.toLowerCase() === language.url.toLowerCase();

            languagesHtml += `
                <li>
                    <a
                        href="${language.url}"
                        data-language="${language.code}"
                        data-country="${currentStore.country.country_code}"
                        class="${isActive ? 'active' : ''}">
                        <span>${language.code.toUpperCase()}</span>
                        <div class="tooltip-block">
                            ${language.name}
                        </div>
                    </a>
                </li>`;
        });

        selectedLanguage.innerHTML = `
            <ul class="country-languages selected-country-languages">
                ${languagesHtml}
            </ul>
        `;
    }
    // ----------------------------
    // Activate Region Tab
    // ----------------------------
    const regionId = `region-${currentStore.region.name
        .toLowerCase()
        .replace(/\s+/g, '-')}`;

    document.querySelectorAll('.region-tab').forEach(tab => {
        tab.classList.toggle(
            'active',
            tab.dataset.target === regionId
        );
    });

    document.querySelectorAll('.region-content-group').forEach(group => {
        group.classList.toggle(
            'active',
            group.id === regionId
        );
    });

    // ----------------------------
    // Activate Current Language
    // ----------------------------
    document.querySelectorAll('.country-languages a').forEach(link => {
        link.classList.remove('active');

        if (
            link.dataset.country === currentStore.country.country_code &&
            link.dataset.language.toLowerCase() === currentStore.language.code.toLowerCase()
        ) {
            link.classList.add('active');
        }
    });
}



loadCountrySwitcher();
bindLanguageSwitcher();
const $toggle = $('header #locationDropdownToggle');
const $panel = $('header #locationSlidePanel');
const $closeBtn = $('header #locationPanelClose');
const $dropdown = $('header .location-dropdown');
$toggle.on('click', function (e) {
    e.stopPropagation();

    if ($panel.is(':visible')) {
        closePanel($panel,$dropdown);
    } else {
        openPanel($panel,$dropdown);
    }
});

$closeBtn.on('click', function () {
    closePanel($panel,$dropdown);
});

$(document).on('click', function (e) {
    if (
        $panel.is(':visible') &&
        !$panel.is(e.target) &&
        $panel.has(e.target).length === 0 &&
        !$toggle.is(e.target) &&
        $toggle.has(e.target).length === 0
    ) {
        closePanel($panel,$dropdown);
    }
});

$('.location-slide-panel').on('click', '.region-tab', function () {
    const target = $(this).data('target');
    $('.location-slide-panel .region-tab').removeClass('active');
    $('.location-slide-panel .region-content-group').removeClass('active');

    $(this).addClass('active');
    $('#' + target).addClass('active');
});